import React, { useContext } from "react";
import { Row, Col } from "react-bootstrap";
import { useQuery } from "@apollo/client";

import { GET_FILE_UPLOAD_MENUS } from "../../../queries/archiveQrys/secureQrys/fileUploadQrys";
import FileUploadForm from "./FileUploadForm";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorBoundary";
import HeaderBox from "../../reuseableComponents/headerBox/HeaderBox";
import { UserContext } from "../../reuseableComponents/auth/UserContext";

const FileUploadPage = () => {
  const { user } = useContext(UserContext);
  const { loading, error, data } = useQuery(GET_FILE_UPLOAD_MENUS);

  if (loading || error) {
    return (
      <div className="page-container file-upload-container">
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='fileUploadPage'>
              <h3 style={{ color: "#fff" }}>File Upload</h3>
            </HeaderBox>
          </Col>
        </Row>
        <Row>
          <Col>{loading ? <SkeletonLoader width='100%' /> : error ? <ErrorHandler error={error} /> : ""}</Col>
        </Row>
      </div>
    );
  }
  return (
    <div className="page-container file-upload-container">
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"} cypressid='fileUploadPage'>
            <h3 style={{ color: "#fff" }}>File Upload</h3>
          </HeaderBox>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <FileUploadForm menus={data} user={user} />
        </Col>
      </Row>
    </div>
  );
};

export default FileUploadPage;
